import { render, staticRenderFns } from "./js.vue?vue&type=template&id=3b2e6a60&scoped=true&"
import script from "./js.vue?vue&type=script&lang=js&"
export * from "./js.vue?vue&type=script&lang=js&"
import style0 from "./js.vue?vue&type=style&index=0&id=3b2e6a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e6a60",
  null
  
)

export default component.exports